import React from 'react'
import {Util} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {LinkButton} from '@components/common/base/buttons'
import {Icon} from '@components/common/base/icon'
import {getPathFromHub} from '@components/movement-templates/movement-row'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {ChatUtils} from '@extensions/chat-utils'
import {globals} from '@extensions/globals-base'
import {PageService} from '@extensions/page-service'
import {Task as TaskUtil} from '@extensions/task'

export const MirroredTasks = (props: {task: Hub; mirroredHubs: Hub[]}) => {
  const {task, mirroredHubs = []} = props

  const mirroredHubsIds = mirroredHubs.map(h => h.id)

  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'current',
    {
      filter: [task?.id, ...mirroredHubsIds] as DataObjectId[],
      debounceTime: 100
    },
    () => forceUpdate(),
    [task?.id, JSON.stringify(mirroredHubsIds)]
  )

  return (
    <div className="flex flex-col gap-8">
      {mirroredHubs.map((m, idx) => (
        <MirroredTask key={task.id + idx} task={task} mirroredHub={m} />
      ))}
    </div>
  )
}

export const MirroredTask = (props: {task: Hub; mirroredHub: Hub}) => {
  const {task, mirroredHub} = props
  const path = getPathFromHub(mirroredHub.location)
  if (!path) {
    return null
  }

  return (
    <div className="flex gap-4 items-start">
      <Icon color="placeholder" icon="IconCustomMirroredTask" />

      {mirroredHub.id === task.id ? (
        <div className="cursor-default text-primary text-xs-regular">
          {path}
        </div>
      ) : (
        <MirroredLink path={path} mirroredHub={mirroredHub} />
      )}
    </div>
  )
}

export const MirroredLink = (props: {mirroredHub: Hub; path: string}) => {
  const {mirroredHub, path} = props

  if (Util.isUUID(mirroredHub.title)) {
    return (
      <div className="cursor-default text-primary text-xs-regular">{path}</div>
    )
  }

  return (
    <LinkButton
      size="small"
      noPaddings
      truncate={false}
      className={'max-w-[calc(100%-20px)]'}
      onClick={() => {
        const board = TaskUtil.parentBoard(mirroredHub)
        if (board) {
          PageService.goToBoard(board.id, globals.getCompanyId())
        }

        setTimeout(() => {
          ChatUtils.openChat(mirroredHub)
        }, 500)
      }}
    >
      {path}
    </LinkButton>
  )
}
